export default __webpack_public_path__ + "static/silverXltag-acd0cee72ff8921e139183caf56a3843.png";